export const TEST_PARAMETER_MAP = {
  EQUAL_TO: 'Equal To',
  GREATER_THAN: 'Greater Than',
  LESS_THAN: 'Lower Than',
  GREATER_OR_EQUAL_TO: 'Greater Or Equal To',
  LOWER_OR_EQUAL_TO: 'Lower Or Equal To',
};
